import Container from '../../Container/Container';
import { HeadlineAlign, HeadlineColor } from '../../Headline/consts';
import Headline from '../../Headline/Headline';
import Section from '../../Section/Section';
import type { PressPageTitleProps } from './interfaces';
import styles from './PressPageTitle.module.scss';

const PressPageTitle = ({ title, subText }: PressPageTitleProps) => {
  return (
    <Section>
      <Container className={styles.base}>
        <Headline
          headlineColor={HeadlineColor.Gradient}
          level={2}
          subText={subText}
          tag="h2"
          align={HeadlineAlign.Left}
          isCustomWidth={true}
        >
          {title}
        </Headline>
      </Container>
    </Section>
  );
};

export default PressPageTitle;
